import AiSummary from './AiSummary.vue';

export default AiSummary;
